export default "__VITE_ASSET__19af1db3__"